import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { deepDiver } from 'helpers/utilities';
import { localize } from 'react-localize-redux';

import { Field, reduxForm } from 'redux-form';

import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import * as validator from 'helpers/Validator';
import renderDatePicker from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import { AccentColor } from 'helpers/AccentColorHelper';

import FormControl from '@material-ui/core/FormControl';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from '@material-ui/core/MenuItem';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  button: {
    color: 'white',
    height: '40px',
  },
  add_cotenant_button: {
    color: 'white',
  },
};

const MOVE_OUT_INSPECTION = 5;
const PROPERTY_SHOWING = 6;

class ShowingsForm extends Component {
  validateShowingsForm = value => {
    const date = new Date();
    return validator.showingFormValidation(
      value,
      this.props.maxDate || new Date(date.setDate(date.getDate() + 365))
    );
  };

  render() {
    const { handleSubmit, buttonLabel } = this.props;

    return (
      <div className="row" style={{ margin: 'auto', maxWidth: '250px', height: '280px' }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xs-12" style={{ marginTop: '5px', marginBottom: '15px' }}>
              <label
                style={{
                  width: '100%',
                  textAlign: 'initial',
                  fontSize: '11px',
                  margin: '11px -10px -10px 15px',
                  marginLeft: '15px',
                  position: 'absolute',
                  top: '-6px',
                  left: '15px',
                }}
                aria-label={this.props.translate('bookingDate').props.children}
              >
                {this.props.translate('bookingDate')}
              </label>
              <Field
                name="date"
                component={renderDatePicker}
                type="date"
                minDate={new Date()}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                validate={this.validateShowingsForm}
              />
            </div>
            {this.renderUnitTypeSelect()}
            {this.renderDurationSelect()}
          </div>
          <div className="row" style={{ textAlign: 'center', marginTop: '2rem' }}>
            <FlatButton
              label={buttonLabel || this.props.translate('book')}
              type="submit"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
              tabIndex="0"
            />
          </div>
        </form>
      </div>
    );
  }

  renderUnitTypeSelect = () => {
    const isAmenity = this.props.amenityType !== undefined;
    if (isAmenity) {
      return null;
    }
    if (this.props.hideUnitTypes) {
      return null;
    }
    return (
      <div className="col-xs-12" style={{ textAlign: 'initial' }}>
        <FormControl>
          <label
            style={{ width: '100%' }}
            aria-label={this.props.translate('unitType').props.children}
          >
            <Field
              name="unit_type"
              component={OutlinedSelect}
              validate={[validator.required]}
              disabled={this.props.lockUnitType}
              label={this.props.translate('unitType')}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            >
              {this.props.unitTypes.map(
                unitType =>
                  unitType && Number.isInteger(unitType.value) ? (
                    <MenuItem key={`unit_type_${unitType.value}`} value={unitType.value}>
                      {!unitType.translation_key && unitType.label}
                      {unitType.translation_key &&
                        getTranslatedString(`standardUnitTypes.${unitType.translation_key}`)}
                    </MenuItem>
                  ) : null
              )}
            </Field>
          </label>
        </FormControl>
      </div>
    );
  };
  renderDurationSelect = () => {
    const { amenityType, maxBookingTime, minBookingTime, amenityDurationType } = this.props;
    const isAmenity = amenityType !== undefined;
    if (!isAmenity || amenityType === MOVE_OUT_INSPECTION || amenityType === PROPERTY_SHOWING) {
      return null;
    }

    let bookingTimeOptions = [],
      dayOrHourTranslations = '';

    if (amenityDurationType === 'night') {
      bookingTimeOptions = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ];
      dayOrHourTranslations = 'night';
    } else if (amenityDurationType === 'day') {
      bookingTimeOptions = ['Full'];
      dayOrHourTranslations = 'day';
    } else {
      bookingTimeOptions = [
        0.5,
        1,
        1.5,
        2,
        2.5,
        3,
        3.5,
        4,
        4.5,
        5,
        5.5,
        6,
        6.5,
        7,
        7.5,
        8,
        8.5,
        9,
        9.5,
        10,
        10.5,
        11,
        11.5,
        12,
      ];
      dayOrHourTranslations = 'hour';
    }

    const listItems = bookingTimeOptions.map(option => {
      if (maxBookingTime && maxBookingTime > 0 && option > maxBookingTime) return undefined;
      if (minBookingTime && maxBookingTime > 0 && option < minBookingTime) return undefined;

      let optionValue = option;
      if (option === 'Full') {
        optionValue = 0;
      }

      return (
        <MenuItem key={option} value={optionValue} style={{ textTransform: 'inherit' }}>
          {this.props.translate(dayOrHourTranslations, { number: option })}
        </MenuItem>
      );
    });

    return (
      <div className="col-xs-12" style={{ marginTop: '8px' }}>
        <label
          style={{ width: '100%' }}
          aria-label={this.props.translate('bookingLength').props.children}
        >
          <Field
            name="requested_booking_length"
            component={OutlinedSelect}
            validate={[validator.required]}
            label={this.props.translate('bookingLength')}
          >
            {listItems}
          </Field>
        </label>
      </div>
    );
  };
}

export default compose(
  connect(state => {
    let unitTypes = state.landlordProperties.unitTypes;
    if (unitTypes && unitTypes.length === 0) {
      unitTypes = state.landlordUsers.unitTypes;
    }
    if (unitTypes && unitTypes.length === 0) {
      unitTypes = state.companyDetails.companyPreferences.unit_types;
    }
    return {
      unitTypes: unitTypes || [],
      displayCotenantsForm: state.tenantApplication.showCotenantsForm,
      initialValues: {
        unit_type: deepDiver(state, 'form.add_showing_form.values.desired_unit'),
      },
    };
  }),
  reduxForm({
    form: 'book_showing',
    forceUnregisterOnUnmount: true,
  })
)(localize()(ShowingsForm));
